/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import MyLatLonEditor from "./LatLonEditor";
import DateTimePicker from "react-datetime";
import DoiTacEditDialog from "../danhmuc/DoiTacEditDialog";
import VungBienEditDialog from "../danhmuc/VungBienEditDialog";
import KhuVucEditDialog from "../danhmuc/KhuVucEditDialog";
import ThietBiEditDialog from '../danhmuc/ThietBiEditDialog';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";
import { ContactSupportOutlined } from "@material-ui/icons";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");

const defaultRecord = {
  MaNguonTin: null,
  TenNguonTin: null,
  PhuongThuc: "1",
  ThoiGianBaoNan: new Date(),
  ThoiGianBiNan: new Date(),
  LoaiTB: null,
  TanSo: null,
  Lat: null,
  Lon: null,
  LoaiVung: "1", //default la vung bien viet nam
  MaVung: null,
  MaKV: null,
  ViTri: null,
};

class SuKienTaiNanControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      expanded: false,
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc nguon tin
      loading_nguontin: true, // co dang load ding danh muc nguon tin ko
      source_nguontin: [], //danh muc options cho nguon tin
      open_them_doitac: false,
      //danh muc loai thiet bi
      loading_thietbi: true, //dang load danh muc thiet bi
      source_thietbi: [],
      open_them_thietbi: false,
      //danh muc vung bien
      loading_vungbien: true, //dang load danh muc vung bien
      source_vungbien: [],
      list_vungbien: [], //danh sach vung bien dang hien thi
      open_them_vungbien: false,
      //danh muc khu vuc bien
      loading_khuvuc: true,
      source_khuvuc: [],
      list_khuvuc: [],
      open_them_khuvuc: false,
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: { error: false },
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "MaNguonTin",
      "TenNguonTin",
      "PhuongThuc",
      "ThoiGianBaoNan",
      "ThoiGianBiNan",
      "LoaiTB",
      "TanSo",
      "Lat",
      "Lon",
      "LoaiVung",
      "MaVung",
      "MaKV",
      "ViTri",
    ]);
    s.canSaved = s.dataChanged;
    //thay doi hien thi combo
    if (fieldName === "LoaiVung") {
      var loaivung = value;
      var list_combo = [];
      this.state.source_vungbien.map((item, index) => {
        if (item.LoaiVung + "" === loaivung) {
          list_combo.push({ value: item.MaVung, label: item.TenVung });
        }
      });
      s.list_vungbien = list_combo;
      s.after.MaVung = ""; //clear
    }
    if (fieldName === "LoaiVung" || fieldName === "MaVung") {
      var mavung = s.after.MaVung.value + "";
      console.log(mavung, "ma vung day nay", this.state.source_khuvuc);
      var list_combo = [];
      this.state.source_khuvuc.map((item, index) => {
        console.log("compare", item.MaVung, mavung);
        if (item.MaVung + "" === mavung) {
          list_combo.push({ value: item.MaKV, label: item.TenKhuVuc });
        }
      });
      s.list_khuvuc = list_combo;
      s.after.MaKV = ""; //clear
      console.log(list_combo);
    }
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("tainan", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveTainan",
          sukienLayer.chuanHoaSukien("tainan", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("doitac/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaDoiTac, label: item.TenDoiTac })
        );
        this.setState({ source_nguontin: list, loading_nguontin: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_nguontin: false });
      });
    //load danh muc thiet bi
    server
      .query("thietbi/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.LoaiTB, label: item.TenLoaiTB })
        );
        this.setState({ source_thietbi: list, loading_thietbi: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_thietbi: false });
      });
    //load danh muc vung bien
    server
      .query("vungbien/getall")
      .then((response) => {
        var list = [];
        var list_combo = []; //danh sach de hien thi tren combo
        var loaivung = this.state.after.LoaiVung + "";
        response.map((item, index) => {
          list.push(item);
          if (item.LoaiVung + "" === loaivung) {
            list_combo.push({ value: item.MaVung, label: item.TenVung });
          }
        });
        this.setState({
          source_vungbien: list,
          list_vungbien: list_combo,
          loading_vungbien: false,
        });
        console.log("loai vung =", loaivung, " danh muc:", list_combo);
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_vungbien: false });
      });
    //load danh muc khu vuc
    server
      .query("khuvuc/getall")
      .then((response) => {
        var list = [];
        var list_combo = []; //danh sach de hien thi tren combo
        var mavung =
          (this.state.after.MaVung &&
          this.state.after.MaVung.hasOwnProperty("value")
            ? this.state.after.MaVung.value
            : this.state.after.MaVung) + "";
        response.map((item, index) => {
          list.push(item);
          if (item.MaVung + "" === mavung) {
            list_combo.push({ value: item.MaKV, label: item.TenKhuVuc });
          }
        });
        this.setState({
          source_khuvuc: list,
          list_khuvuc: list_combo,
          loading_khuvuc: false,
        });
        console.log("ma vung=", mavung, "danh muc:", list_combo);
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_khuvuc: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        expanded:
          props.expanded !== state.expanded ? props.expanded : state.expanded,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion
        disabled={this.props.disabled}
        defaultExpanded={this.props.value !== undefined}
        expanded={this.state.expanded || this.props.value !== undefined}
        onChange={(event, expanded) => this.setState({ expanded: expanded })}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Thông tin tai nạn</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <InputLabel
                id="labelManguontin"
                onClick={
                  global.User.Quyen.R121
                    ? (event) => this.setState({ open_them_doitac: true })
                    : undefined
                }
                className={
                  this.state.validateStatus.MaNguonTin !== undefined
                    ? classes.redLabel
                    : classes.normalLabel
                }
              >
                Nguồn tin:
              </InputLabel>
              {this.state.loading_nguontin ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaNguonTin"
                  options={this.state.source_nguontin}
                  placeholder="Chọn nguồn tin"
                  labelId="labelManguontin"
                  value={this.state.after.MaNguonTin}
                  onChange={(item) => {
                    this.saveField("MaNguonTin", item);
                  }}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTenNguonTin"
                className={classes.textbox}
                label="Tên khác(*):"
                value={this.state.after.TenNguonTin}
                inputProps={{
                  className: classes.uppercaseText,
                  maxLength: 200,
                }}
                onChange={(event) =>
                  this.saveField("TenNguonTin", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Phương thức:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.PhuongThuc}
                  onChange={(event) =>
                    this.saveField("PhuongThuc", event.target.value)
                  }
                >
                  <MenuItem value={"1"}>Fax</MenuItem>
                  <MenuItem value={"2"}>Điện thoại</MenuItem>
                  <MenuItem value={"3"}>Email</MenuItem>
                  <MenuItem value={"4"}>Khác</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <InputLabel
                id="labelThoiGianBaoNan"
                className={
                  this.state.validateStatus.ThoiGianBaoNan !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                T.gian báo nạn(*):
              </InputLabel>
              <DateTimePicker
                id="txtThoigianBaoNan"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.ThoiGianBaoNan}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.ThoiGianBaoNan === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('ThoiGianBaoNan', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField(
                    "ThoiGianBaoNan",
                    date && date.toDate ? date.toDate() : null
                  )
                }
              />
            </Grid>
            <Grid item xs={2}>
              <InputLabel
                id="labelThoiGianBiNan"
                className={
                  this.state.validateStatus.ThoiGianBiNan !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                T.gian bị nạn(*):
              </InputLabel>
              <DateTimePicker
                id="txtThoiGianBiNan"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.ThoiGianBiNan}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.ThoiGianBiNan === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('ThoiGianBiNan', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField(
                    "ThoiGianBiNan",
                    date && date.toDate ? date.toDate() : null
                  )
                }
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel
                id="labelThietbi"
                className={
                  this.state.validateStatus.LoaiTB !== undefined
                    ? classes.redLabel
                    : classes.normalLabel
                }
                onClick={
                  global.User.Quyen.R191
                    ? (event) => this.setState({ open_them_thietbi: true })
                    : undefined
                }
              >
                Thiết bị:
              </InputLabel>
              {this.state.loading_nguontin ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboLoaiTB"
                  options={this.state.source_thietbi}
                  placeholder="Loại thiết bị"
                  labelId="labelThietbi"
                  value={this.state.after.LoaiTB}
                  onChange={(value) => this.saveField("LoaiTB", value)}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTanSo"
                className={classes.textbox}
                label="Tần số(*):"
                value={this.state.after.TanSo}
                inputProps={{
                  maxLength: 20,
                }}
                onChange={(event) =>
                  this.saveField("TanSo", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <MyLatLonEditor
                id="txtLat"
                latlon="lat"
                label="Vĩ độ:"
                value={this.state.after.Lat}
                onChange={(lat) => this.saveField("Lat", lat)}
              />
            </Grid>
            <Grid item xs={2}>
              <MyLatLonEditor
                id="txtLon"
                latlon="lon"
                label="Kinh độ:"
                value={this.state.after.Lon}
                onChange={(lon) => this.saveField("Lon", lon)}
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="txtViTri"
                className={classes.textbox}
                label="Ghi chú khu vực:"
                value={this.state.after.ViTri}
                inputProps={{
                  maxLength: 200,
                }}
                onChange={(event) =>
                  this.saveField("ViTri", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Thuộc:</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.LoaiVung}
                  onChange={(event) =>
                    this.saveField("LoaiVung", event.target.value)
                  }
                >
                  <MenuItem value={"1"}>Việt Nam</MenuItem>
                  <MenuItem value={"2"}>Nước ngoài</MenuItem>
                  <MenuItem value={"3"}>Vùng nước cảng</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <InputLabel
                id="labelVungBien"
                onClick={
                  global.User.Quyen.R151
                    ? (event) => this.setState({ open_them_vungbien: true })
                    : undefined
                }
              >
                Vùng biển:
              </InputLabel>
              {this.state.loading_vungbien ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaVung"
                  options={this.state.list_vungbien}
                  placeholder="---Chọn---"
                  labelId="labelVungBien"
                  value={this.state.after.MaVung}
                  onChange={(value) => this.saveField("MaVung", value)}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={4}>
              <InputLabel
                id="labeKhuvuc"
                onClick={
                  global.User.Quyen.R161 && this.state.after.MaVung !== ''
                    ? (event) => this.setState({ open_them_khuvuc: true })
                    : undefined
                }
              >
                Khu vực:
              </InputLabel>
              {this.state.loading_khuvuc ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaKV"
                  options={this.state.list_khuvuc}
                  placeholder="---Chọn---"
                  labelId="labeKhuvuc"
                  value={this.state.after.MaKV}
                  onChange={(value) => this.saveField("MaKV", value)}
                ></SelectFilter>
              )}
            </Grid>
            

            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
          {this.state.open_them_doitac ? (
            <DoiTacEditDialog
              visible={this.state.open_them_doitac}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              onClose={(result) => {
                this.setState({ open_them_doitac: false }, () =>
                  console.log(result)
                );
              }}
              onSaved={(record) => {
                var list = [].concat(this.state.source_nguontin);
                var new_item = {
                  value: record.MaDoiTac,
                  label: record.TenDoiTac,
                };
                list.unshift(new_item);
                this.setState({
                  source_nguontin: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, MaNguonTin: new_item },
                });
              }}
            />
          ) : null}
          {this.state.open_them_vungbien ? (
            <VungBienEditDialog
              visible={this.state.open_them_vungbien}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              LoaiVung={this.state.after.LoaiVung}
              onClose={(result) => {
                this.setState({ open_them_vungbien: false });
              }}
              onSaved={(record) => {
                var source = [].concat(this.state.source_vungbien);
                var new_item = { value: record.MaVung, label: record.TenVung };
                source.unshift(new_item);
                var list = [].concat(this.state.list_vungbien);
                list.unshift(new_item);
                this.setState(
                  {
                    source_vungbien: source,
                    list_vungbien: list,
                    dataChanged: true,
                    canSaved: true,
                    after: {
                      ...this.state.after,
                      LoaiVung: record.LoaiVung,
                      MaVung: new_item,
                    },
                  },
                  () => console.log("state", this.state)
                );
              }}
            />
          ) : null}
          {this.state.open_them_khuvuc ? (
            <KhuVucEditDialog
              visible={this.state.open_them_khuvuc}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              MaVung={this.state.after.MaVung}
              onClose={(result) => {
                this.setState({ open_them_khuvuc: false });
              }}
              onSaved={(record) => {
                var source = [].concat(this.state.source_khuvuc);
                var new_item = { value: record.MaKV, label: record.TenKhuVuc };
                source.unshift(new_item);
                var list = [].concat(this.state.list_khuvuc);
                list.unshift(new_item);
                this.setState(
                  {
                    source_khuvuc: source,
                    list_khuvuc: list,
                    dataChanged: true,
                    canSaved: true,
                    after: {
                      ...this.state.after,
                      MaKV: new_item,
                    },
                  },
                  () => console.log("state", this.state)
                );
              }}
            />
          ) : null}
          {this.state.open_them_thietbi ? (
              <ThietBiEditDialog
                visible={this.state.open_them_thietbi}
                fullWidth={true}
                maxWidth={"sm"}
                EditMode="them"
                onClose={(result) => {
                  this.setState({ open_them_thietbi: false }
                  );
                }}
                onSaved={(record) => {
                var list = [].concat(this.state.source_thietbi);
                var new_item = {
                  value: record.LoaiTB,
                  label: record.TenLoaiTB,
                };
                list.unshift(new_item);
                this.setState({
                  source_thietbi: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, LoaiTB: new_item },
                });
              }}
              />
            ) : null}

        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: "black",
  },
  redLabel: {
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienTaiNanControl);
